/// <reference path="./TypeLite.Net4.d.ts" />
export class AppConfig {
	public static get GlobalSetting(): SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.ServiceAvailabilityModel {
		return (<any>window).serviceAvailability.globalSettings;
	}

	public static TranslationNamespaces: any = {
		Default: 'SkodaAuto.Marvin.ServiceAvailability.Web.App.Resources',
		Common: 'SkodaAuto.Marvin.K2Tools.Common.Resources',
		CodeList: 'SkodaAuto.Marvin.K2Tools.CodeList'
	};

	public static AvailableListConstants: any = {
		CountryTranslationKeyPrefix: 'FormDesigner.Country.',
		CountryTranslationKeyPostfix: '.DisplayName'
	}

	public static GetResourceProviderApiUrl = () => {
		return `${location.protocol}//${location.host}${AppConfig.GetBaseName()}/api/Resource/GetDataResources`;
	}

	public static GetBaseName = () => {
		const webAppRoute = !AppConfig.GlobalSetting.WebAppRoute ? '' : `/${AppConfig.GlobalSetting.WebAppRoute}`;
		return `${webAppRoute}/${AppConfig.GlobalSetting.Bid}/${AppConfig.GlobalSetting.Culture}`.replace('//', '/');
	};
}